var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-select',_vm._g(_vm._b({attrs:{"loading":_vm.options.length === 0,"options":_vm.options}},'q-select',_vm.vAttrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }